import { render, staticRenderFns } from "./MitraProductView.vue?vue&type=template&id=727f9f58&"
import script from "./MitraProductView.vue?vue&type=script&lang=js&"
export * from "./MitraProductView.vue?vue&type=script&lang=js&"
import style0 from "./MitraProductView.vue?vue&type=style&index=0&id=727f9f58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports